/*eslint-disable */
const $ = window.jQuery = require('jquery');
export default {
  name: 'presentation-version-upgrade',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {
    // bus.$emit('showHeaderbtn', false);
  },
  methods: {

  },
  beforeCreate: function () {
    $('body').addClass('presentation_view')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('presentation_view')
    next();
  },
}